
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'SliderRight'
})
export default class SliderRight extends Vue {}
